import CommandResult from './command-result';
import { classForType } from '@intercom/embercom-composer/blocks/types/base/block';
import InsertBlockCommand from './insert-block';
export default InsertBlockCommand.extend({
  _doInsert(index) {
    let newBlock = this._getNewBlock();
    this.insertBlock(newBlock, index);
    if (this.get('options.selectNewBlock')) {
      this.setSelectionToStartOf(newBlock);
    } else {
      this._setSelection(newBlock, index);
    }
    return CommandResult.create({
      newBlock
    });
  },
  _getNewBlock() {
    let options = this.get('options');
    options.config = this.get('config');
    return classForType(options.blockType).create(options);
  }
});